export const MAX_REFRESH_SUBSCRIBERS = 100;

export const MAX_RETRY_DELAY_MS = 30000;

export const RETRY_BACKOFF_MULTIPLIER = 2;

export const DEFAULT_RETRY_CONFIG = {
  count: 0,
  delay: 1000,
  statusCodes: [408, 500, 502, 503, 504],
};
